<form novalidate #currentForm="ngForm">
  <div class="setup">
    <div class="section-container">
      <div class="label-data label">
        <div class="label">Name</div>
      </div>
      <div class="group stream-data">
        <input
          matInput
          autocomplete="off"
          type="text"
          class="input-data"
          name="testName"
          #testNameInput="ngModel"
          [(ngModel)]="testName"
          (ngModelChange)="nameUpdated()"
          maxlength="80"
          required
        />
        <div
          class="error"
          *ngIf="testNameInput.invalid && (testNameInput.dirty || testNameInput.touched)"
        >
          <mat-error *ngIf="testNameInput?.errors?.required">Name is required</mat-error>
          <mat-error *ngIf="testNameInput.errors.regex && !testNameInput.errors.required"
            >Name should not contain '?,%,/' special characters</mat-error
          >
        </div>
        <div *ngIf="nameExist">
          <mat-error>Name already exist</mat-error>
        </div>
      </div>
    </div>

    <div class="section-container">
      <div class="label-data label">Agent & App</div>
      <div>
        <nrwl-agent-picker
          [testType]="'multistep'"
          [originatorDevice]="selectedOriginator"
          [editMode]="editMode"
          [originatorMultiSelection]="true"
          [testMode]="testMode"
          [showTestMode]="false"
          (emitAgents)="onAgentChange($event)"
        ></nrwl-agent-picker>
      </div>
      <div class="icon">
        <i class="mdi mdi-ray-start-vertex-end separator-icon"></i>
      </div>
      <div class="app-container">
        <div [ngClass]="{ appDisabled: editMode }">
          <div class="destination">Destination</div>
          <div class="select-app">
            <viavi-common-dropdown
              [dropDownData]="appDropDown"
              [configuration]="dropdownConfiguration"
              (valueChange)="applicationSelection($event)"
              [defaultSelection]="selectedApp"
              *ngIf="appDropDown && appDropDown.length > 0 && dropdownConfiguration"
              [isCustomDropdown]="true"
            ></viavi-common-dropdown>
          </div>
        </div>
      </div>
    </div>
    <div class="section-container">
      <div class="label-data label">Test method</div>
      <div class="test-section">
        <div class="test-item" [ngClass]="{ testMethodDisable: editMode }">
          <div class="radio-button" (click)="selectTestUsingBrowser()">
            <i *ngIf="scriptSelection" class="mdi mdi-radiobox-blank"></i>
            <i *ngIf="browserSelection" class="blue-icon mdi mdi-radiobox-marked"></i>
          </div>
          <div class="test-name">
            <div class="label">Single Web Page</div>
            <div class="label-description">Use application's URL</div>
          </div>
        </div>
        <div
          class="test-item script-item"
          *ngIf="scriptPicklist.length"
          [ngClass]="{ testMethodDisable: editMode }"
        >
          <div class="radio-button" (click)="selectTestUsingScript()">
            <i *ngIf="browserSelection" class="mdi mdi-radiobox-blank"></i>
            <i *ngIf="scriptSelection" class="blue-icon mdi mdi-radiobox-marked"></i>
          </div>
          <div class="test-name">
            <div class="label">Scripted Web Transaction</div>
            <div class="label-description">
              Capture web performance metrics from multiple areas of your application using a script
            </div>
            <mat-select
              class="option-list"
              #selectedScriptNameInput="ngModel"
              name="selectedScriptName"
              [(ngModel)]="selectedScriptName"
              [ngClass]="{ disabled: editMode || browserSelection }"
              [disabled]="editMode || browserSelection"
              (ngModelChange)="changeScript()"
            >
              <ng-container *ngFor="let item of scriptPicklist">
                <mat-option [value]="item">{{ item }} </mat-option>
              </ng-container>
            </mat-select>
          </div>
        </div>
      </div>
    </div>
    <div class="section-container">
      <div class="label-data label">Schedule</div>
      <div class="scheduler-section">
        <div class="section-data">
          <div class="group start-input">
            <div class="label">Starts</div>
            <input
              matInput
              autocomplete="off"
              type="text"
              class="input-data disabled"
              [(ngModel)]="startScheduleVal"
              disabled
            />
          </div>
          <div class="group repeat-DD">
            <div class="label">Repeats</div>
            <mat-select
              class="option-list"
              [ngClass]="{ disabled: isDisabledScheduler || editMode }"
              #repeatScheduleValInput="ngModel"
              name="repeatScheduleVal"
              [disabled]="isDisabledScheduler || editMode"
              (ngModelChange)="onRepeatValChange($event)"
              [(ngModel)]="repeatScheduleVal"
              required
            >
              <mat-option [value]="scheduleInterval.FIVE_MINUTES">Every 5 minute</mat-option>
              <mat-option [value]="scheduleInterval.FIFTEEN_MINUTES">Every 15 minute</mat-option>
              <mat-option
                [value]="scheduleInterval.THIRTY_MINUTES"
                *ngIf="endScheduleVal === runType.ON_GOING"
                >Every 30 minute</mat-option
              >
              <mat-option
                [value]="scheduleInterval.HOUR"
                *ngIf="endScheduleVal === runType.ON_GOING"
                >Every 1 hour</mat-option
              >
              <mat-option [value]="scheduleInterval.DAY" *ngIf="endScheduleVal === runType.ON_GOING"
                >Every 1 day</mat-option
              >
              <mat-option
                [value]="scheduleInterval.WEEK"
                *ngIf="endScheduleVal === runType.ON_GOING"
                >Every 1 week</mat-option
              >
            </mat-select>
          </div>
          <div class="group repeat-DD">
            <div class="label">Ends</div>
            <mat-select
              class="option-list"
              [ngClass]="{ disabled: editMode }"
              #endScheduleValInput="ngModel"
              name="endScheduleVal"
              (ngModelChange)="onEndScheduleValChange($event)"
              [(ngModel)]="endScheduleVal"
              [disabled]="editMode"
              required
            >
              <mat-option *ngIf="!isDisabledScheduler" [value]="runType.ON_GOING">
                Never
              </mat-option>
              <mat-option [value]="runType.ON_DEMAND"> In 8 hours</mat-option>
            </mat-select>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
